import i18n from "common/languageHandling/i18n";
import React from "react";

interface IErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<any, IErrorBoundaryState> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    this.setState({
      hasError: true,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <h3>{i18n.t("An error occurred, try reloading the page!")}</h3>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
